import { getClassLevel } from "../shared/getClassLevel";
import { evaluateHuntersMark } from "./huntersMark";
import { evaluateColossusSlayer } from "./colossusSlayer";
import { hasSubclassFeature } from "../../../../shared/rules/subclasses/index.mjs";
import { COLOSSUS_SLAYER_FEATURE_ID } from "../../../../shared/rules/subclasses/ranger/huntersPrey.mjs";

// Hunter's Mark is only on the Ranger spell list, so its hit damage is owned by the Ranger adapter.
// Hunter's Colossus Slayer joins it while that Hunter's Prey option is chosen.
const rangerAdapter = Object.freeze({
  id: "ranger",
  getClassLevel: (character) => getClassLevel(character, "ranger"),
  evaluateOnHit(context, queries) {
    const mark = evaluateHuntersMark({ context, queries });
    return hasSubclassFeature(context?.attacker?.entity, COLOSSUS_SLAYER_FEATURE_ID)
      ? [mark, evaluateColossusSlayer({ context })] : mark;
  },
});

export default rangerAdapter;
